import { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  setPrecioBase,
  setIdProyecto,
  setLogoPdf,
  setLogoResumen,
  setGAId,
  setGrupoProyecto,
  setLogoConfiguraciones,
  setNombrePdf,
  setLoader
} from '../modules/reducer'

import axios from 'axios'

import pathIntranet from '../ruta'

let estancias = undefined
let acabados = undefined
let opciones = undefined
let subopciones = undefined

const Loader = ({
  url,
  setPrecioBase,
  setIdProyecto,
  setLogoPdf,
  setLogoResumen,
  setGAId,
  setGrupoProyecto,
  setLogoConfiguraciones,
  setNombrePdf,
  setLoader
}) => {
  useEffect(() => {
    axios({
      method: 'get',
      url: `${pathIntranet}/administracion/proyectos?_format=json&url=${url}`,
      auth: {
        username: 'leeestancias1',
        password: 'ed3ok5Rd$2fkDdc'
      }
    }).then(function(response) {
      setPrecioBase(response.data[0].precio_base * 1)
      setIdProyecto(response.data[0].nid)
      setLogoPdf(response.data[0].logo_pdf)
      setLogoResumen(response.data[0].logo_resumen)
      setLogoConfiguraciones(response.data[0].logo_configuraciones)
      setNombrePdf(
        response.data[0].nombre_pdf !== ''
          ? response.data[0].nombre_pdf
          : 'larcrea'
      )

      if (response.data[0].ga_id !== '') {
        setGAId(response.data[0].ga_id)
      }

      const ordenEstancias = response.data[0].estancias.split(',')

      //response.data[0].grupo_proyecto

      if (response.data[0].grupo_proyecto !== '') {
        axios({
          method: 'get',
          url: `${pathIntranet}/administracion/grupo-proyecto?_format=json&nid=${
            response.data[0].grupo_proyecto
          }`,
          auth: {
            username: 'leeestancias1',
            password: 'ed3ok5Rd$2fkDdc'
          }
        }).then(function(response1) {
          setGrupoProyecto(response1.data)
        })
      }

      axios({
        method: 'get',
        url: `${pathIntranet}/administracion/estancias-proyecto?_format=json&nid=${
          response.data[0].nid
        }`,
        auth: {
          username: 'leeestancias1',
          password: 'ed3ok5Rd$2fkDdc'
        }
      }).then(function(response1) {
        estancias = response1.data

        if (
          typeof estancias !== 'undefined' &&
          typeof acabados !== 'undefined' &&
          typeof opciones !== 'undefined' &&
          typeof subopciones !== 'undefined'
        ) {
          setLoader(estancias, ordenEstancias, acabados, opciones, subopciones)
        }
      })

      axios({
        method: 'get',
        url: `${pathIntranet}/administracion/calidades-proyecto?_format=json&nid=${
          response.data[0].nid
        }`,
        auth: {
          username: 'leeestancias1',
          password: 'ed3ok5Rd$2fkDdc'
        }
      }).then(function(response2) {
        acabados = response2.data

        if (
          typeof estancias !== 'undefined' &&
          typeof acabados !== 'undefined' &&
          typeof opciones !== 'undefined' &&
          typeof subopciones !== 'undefined'
        ) {
          setLoader(estancias, ordenEstancias, acabados, opciones, subopciones)
        }
      })

      axios({
        method: 'get',
        url: `${pathIntranet}/administracion/opciones-proyecto?_format=json&nid=${
          response.data[0].nid
        }`,
        auth: {
          username: 'leeestancias1',
          password: 'ed3ok5Rd$2fkDdc'
        }
      }).then(function(response3) {
        opciones = response3.data

        if (
          typeof estancias !== 'undefined' &&
          typeof acabados !== 'undefined' &&
          typeof opciones !== 'undefined' &&
          typeof subopciones !== 'undefined'
        ) {
          setLoader(estancias, ordenEstancias, acabados, opciones, subopciones)
        }
      })

      axios({
        method: 'get',
        url: `${pathIntranet}/administracion/subopciones-proyecto?_format=json&nid=${
          response.data[0].nid
        }`,
        auth: {
          username: 'leeestancias1',
          password: 'ed3ok5Rd$2fkDdc'
        }
      }).then(function(response4) {
        subopciones = response4.data

        if (
          typeof estancias !== 'undefined' &&
          typeof acabados !== 'undefined' &&
          typeof opciones !== 'undefined' &&
          typeof subopciones !== 'undefined'
        ) {
          setLoader(estancias, ordenEstancias, acabados, opciones, subopciones)
        }
      })
    })
  })

  return null
}
/*
const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    url: reducer.url.href
  }
}
*/
const mapDispatchToProps = {
  setPrecioBase,
  setIdProyecto,
  setLogoPdf,
  setLogoResumen,
  setGAId,
  setGrupoProyecto,
  setLogoConfiguraciones,
  setNombrePdf,
  setLoader
}

export default connect(
  null,
  mapDispatchToProps
)(Loader)
